<app-header></app-header>
<div class="breadcrumb">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <span>Experience > Education > Skills > Languages > <strong>Options</strong></span>
      </div>
    </div>
  </div>
</div>
<div class="addOptions">
  <div class="container">
    <div class="row">
      <div class="col-lg-7 col-sm-6">
        <h2>Add these sections to your resume</h2>
        <p>These are optional sections.</p>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label><input type="checkbox" name="vehicle" value="Bike"> Professional Summary</label>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label><input type="checkbox" name="vehicle" value="Bike"> Certificates</label>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label><input type="checkbox" name="vehicle" value="Bike"> Accomplishments</label>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label><input type="checkbox" name="vehicle" value="Bike"> Hobbies</label>
            </div>
          </div>
        </div>
        <p>Create your own section</p>
        <div class="form-group input-group">
          <input type="text" [(ngModel)]="other_field" class="form-control form-left" name="others" placeholder="Others">
        </div>
      </div>
      <div class="col-lg-1"></div>
      <div class="col-lg-3 col-sm-6">
        <div class="addOptions__bg">
          <img src="../../../../assets/images/resume_1.jpg" class="img-fluid addOptions__img" />
          <div class="addOptions__overlay"></div>
        </div>
      </div>
      <div class="col-lg-1"></div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="addOptions__buttons">
          <button class="btn btn-default" routerLink="/resume/lang">Back</button>
        </div>
      </div>
      <div class="col-sm-6 text-right">
        <div class="addOptions__buttons">
          <button class="btn btn-primary" (click)="next()">Next</button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
